import { z } from 'zod';

import { schemaBaubeschreibungAnschriftUndObjektart } from './AnschriftUndObjektart';
import { schemaBaubeschreibungDachKellerFenster } from './DachKellerFenster';
import { schemaBaubeschreibungHeizungWarmwasser } from './HeizungWarmwasser';
import { schemaBaubeschreibungSanierungen } from './Sanierungen';
import { schemaBaubeschreibungSanitaerGaragen } from './SanitaerGaragen';

export * from './AnschriftUndObjektart';
export * from './DachKellerFenster';
export * from './HeizungWarmwasser';
export * from './Sanierungen';
export * from './SanitaerGaragen';

export const Baubeschreibung = z.object({
    anschriftUndObjektart: schemaBaubeschreibungAnschriftUndObjektart.default({}),
    dachKellerFenster: schemaBaubeschreibungDachKellerFenster.default({}),
    heizungWarmwasser: schemaBaubeschreibungHeizungWarmwasser.default({}),
    sanierungen: schemaBaubeschreibungSanierungen.default({}),
    sanitaerGaragen: schemaBaubeschreibungSanitaerGaragen.default({}),
});

export type Schema_Baubeschreibung = z.infer<typeof Baubeschreibung>;
export type Schema_Baubeschreibung_Input = z.input<typeof Baubeschreibung>;
